module.exports = __webpack_public_path__ + "static/media/phone.77195468.svg";